import { EntityModel } from '@/interfaces'
import {
  ALL_FIELDS_QUERY,
  CREATE_FIELD_MUTATION,
  DELETE_FIELD_MUTATION,
  FORCE_DELETE_FIELD_MUTATION,
  SINGLE_FIELD_QUERY,
  UPDATE_FIELD_MUTATION,
} from './graphql'
import customBookingFormFieldOptionEntity from '@/entities/customBookingFormFieldOption/entity'
import customBookingFormFieldVisibilityConfigEntity from '@/entities/customBookingFormFieldVisibilityConfig/entity'

const customBookingFormFieldModel: EntityModel = {
  name: 'field',
  namePlural: 'fields',
  uniqueName: 'customBookingFormField',
  uniqueNamePlural: 'customBookingFormFields',
  path: 'travel/booking/custom_data/field',
  baseUrl: '/travel/booking/custom_data/fields',
  translationPrefix: 'entities:customBookingFormField.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_FIELDS_QUERY,
    getSingle: SINGLE_FIELD_QUERY,
    create: CREATE_FIELD_MUTATION,
    update: UPDATE_FIELD_MUTATION,
    delete: DELETE_FIELD_MUTATION,
    forceDelete: FORCE_DELETE_FIELD_MUTATION,
  },
  attributes: {
    inputType: {
      name: 'inputType',
      label: 'entities:customBookingFormField.attributes.inputType.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'TEXT',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:customBookingFormField.attributes.inputType.selectOptions.TEXT.label',
          value: 'TEXT',
        },
        {
          label: 'entities:customBookingFormField.attributes.inputType.selectOptions.TEXTAREA.label',
          value: 'TEXTAREA',
        },
        {
          label: 'entities:customBookingFormField.attributes.inputType.selectOptions.SWITCH.label',
          value: 'SWITCH',
        },
        {
          label: 'entities:customBookingFormField.attributes.inputType.selectOptions.CHECKBOX.label',
          value: 'CHECKBOX',
        },
        {
          label: 'entities:customBookingFormField.attributes.inputType.selectOptions.RADIO.label',
          value: 'RADIO',
        },
        {
          label: 'entities:customBookingFormField.attributes.inputType.selectOptions.SELECT.label',
          value: 'SELECT',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:customBookingFormField.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:customBookingFormField.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:customBookingFormField.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'textarea',
      validationType: 'string',
      validations: [],
    },
    value: {
      name: 'value',
      label: 'entities:customBookingFormField.attributes.value.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    required: {
      name: 'required',
      label: 'entities:customBookingFormField.attributes.required.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    options: {
      name: 'options',
      label: 'entities:customBookingFormField.attributes.options.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return customBookingFormFieldOptionEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    visibilityConfig: {
      name: 'visibilityConfig',
      label: 'entities:customBookingFormField.attributes.visibilityConfig.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return customBookingFormFieldVisibilityConfigEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default customBookingFormFieldModel
